module.exports = __webpack_public_path__ + "media/images/favicon/favicon-32x32-474b9f8fdb69973c2959e8bd9dcea5bd.png";